import React, { useState } from 'react';
import { ClientTag } from '../../atoms/ClientTag';
import { useIndustries } from '../../../hooks/useClients';
import styles from './ClientTags.module.css';

interface ClientTagsProps {
  onTagSelect?: (tag: string) => void;
  selectedTag?: string;
}

export const ClientTags: React.FC<ClientTagsProps> = ({
  onTagSelect,
  selectedTag: externalSelectedTag,
}) => {
  const { industries, loading } = useIndustries();
  const [internalSelectedTag, setInternalSelectedTag] = useState('All');

  // Use external selected tag if provided, otherwise use internal state
  const selectedTag = externalSelectedTag ?? internalSelectedTag;

  const handleTagClick = (tag: string) => {
    if (!externalSelectedTag) {
      setInternalSelectedTag(tag);
    }
    onTagSelect?.(tag);
  };

  // Get tag names from industries
  const tagsToDisplay = industries.map((i) => i.name);

  // Split into two rows: approximately half on top, half on bottom
  const midPoint = Math.ceil(tagsToDisplay.length / 2);
  const firstRow = tagsToDisplay.slice(0, midPoint);
  const secondRow = tagsToDisplay.slice(midPoint);

  // Show minimal loading state
  if (loading && tagsToDisplay.length <= 1) {
    return (
      <div className={styles.clientTags}>
        <div className={styles.tagsContainer}>
          <div className={styles.tagRow}>
            <ClientTag label="All" selected={true} onClick={() => {}} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.clientTags}>
      <div className={styles.tagsContainer}>
        <div className={styles.tagRow}>
          {firstRow.map((tag) => (
            <ClientTag
              key={tag}
              label={tag}
              selected={selectedTag === tag}
              onClick={() => handleTagClick(tag)}
            />
          ))}
        </div>
        {secondRow.length > 0 && (
          <div className={styles.tagRow}>
            {secondRow.map((tag) => (
              <ClientTag
                key={tag}
                label={tag}
                selected={selectedTag === tag}
                onClick={() => handleTagClick(tag)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
